module.exports = __webpack_public_path__ + "img/design_video_background.5172a85d.png";